import React from 'react';
import { IconWithTooltip } from './IconWithTooltip';

export function WarningItem({
  header,
  description,
  howtoFix,
  extraDescription,
  ctaButton,
  iconClassName,
  iconGlyphClassName,
  iconContainerClassName,
  itemClassName = 'text-body-2 relative min-h-[30px] py-1',
  strongClassName = 'text-body-1',
}) {
  return (
    <div className={itemClassName}>
      <IconWithTooltip
        type="warning"
        className={iconClassName}
        iconClassName={iconGlyphClassName}
        containerClassName={iconContainerClassName}
      />
      <div className="text-header-4">{header}</div>
      <p className="leading-snug">{description}</p>
      {extraDescription && extraDescription}
      <div className="pt-2.5">
        {howtoFix ? (
          <>
            <strong className={strongClassName}>How to fix it:</strong>&nbsp;{howtoFix}
          </>
        ) : null}
        {ctaButton && ctaButton}
      </div>
    </div>
  );
}
